import { createContext, useContext } from 'react';
export const SignAndApproveContext = createContext(undefined);
export function useSignAndApproveContext() {
    const context = useContext(SignAndApproveContext);
    if (!context) {
        throw new Error('useSignAndApproveContext must be used within SignAndApproveContext.Provider');
    }
    return context;
}
